import { useEffect, useState } from 'react';
import jwtService from '@/app/services/jwtService';
import { useDispatch } from 'react-redux';
import * as authActions from '@/app/auth/store/actions';
import clsx from 'clsx';
import FuseAnimate from '@/@fuse/core/FuseAnimate/FuseAnimate';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { showMessage } from '@/app/store/actions';
import CustomButton from '@shared/components/CustomButton/CustomButton';
import { useLocation, useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
	root: {
		background: 'url(assets/images/banner/bg.png) no-repeat center',
		backgroundSize: 'cover',
		color: theme.palette.primary.contrastText,
	},
}));

const ProductOwnerLogin = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const classes = useStyles();
	const [complete, setComplete] = useState(false);
	const [success, setSuccess] = useState(false);

	const loginUser = (token, hash, company_id) => {
		jwtService
			.signInWithSingleUseLogin(token, hash, company_id, null)
			.then((response) => {
				setSuccess(true);
				setComplete(true);
				response.doNotRedirect = 1;
				dispatch(authActions.setUserData(response));
				dispatch(
					showMessage({
						message: 'Selected company',
						variant: 'success',
					})
				);
				navigate('/company');
			})
			.catch(() => {
				setSuccess(false);
				setComplete(true);
				dispatch(
					showMessage({
						message: 'Failed to login to company app.',
						variant: 'error',
					})
				);
			});
	};

	useEffect(() => {
		const search = new URLSearchParams(location.search);
		const token = search.get('token');
		const hash = search.get('hash');
		const school_id = search.get('school_id') || null;

		if (token && hash) {
			loginUser(token, hash, school_id);
		} else {
			setSuccess(false);
			setComplete(true);
			dispatch(
				showMessage({
					message: 'Token and hash were not provided.',
					variant: 'error',
				})
			);
		}
	}, []);

	return (
		<div className={clsx(classes.root, 'flex flex-col flex-auto shrink-0 items-center justify-center p-32')}>
			<div className="flex flex-col items-center justify-center w-full">
				<FuseAnimate animation="transition.expandIn">
					<Card className="login-width">
						<CardContent className="flex flex-col items-center justify-center p-32">
							<img alt="logo" className="mb-2 gd text-center logo-img" src="assets/images/logos/logo.png" width={150} />
							<Typography className="mt-11 mb-32 hellloooo" variant="h6">
								{complete ? (success ? 'Opening company page...' : 'Failed to select company.') : 'Logging in...'}
							</Typography>
							<CustomButton height={38} onClick={() => window.history.back()} type="button" width={170}>
								Back to Product Owner
							</CustomButton>
						</CardContent>
					</Card>
				</FuseAnimate>
			</div>
		</div>
	);
};

export default ProductOwnerLogin;
